export const getIpAddress = async () => {
	let ipAddress = null

	await fetch("https://api64.ipify.org")
		.then((res) => res.text())
		.then((ip) => {
			ipAddress = ip
		})
		.catch((error) => {
			console.error("getIpAddress error", error)
		})

	return ipAddress
}
